module.exports = __webpack_public_path__ + "de77a722/img/saly-icon.39e12342.jpg";